// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PayCircleFilledSvg from "@fishx/icons-svg/es/asn/PayCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PayCircleFilled = function PayCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleFilledSvg
  }));
};

PayCircleFilled.displayName = 'PayCircleFilled';
export default React.forwardRef(PayCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PayCircleFilled.js
// module id = 3759
// module chunks = 0